const bnIN= {
    login: {
      title: 'সাইন-ইন করুন',
      sign_in_btn: 'সাইন-ইন করুন'
    },
    bar: {
        logout: 'লগ-আউট করুন',
        languages: 'ভাষা',
        settings: 'সেটিং খুলুন'
    },
    language: {
      name: 'বাংলা (ভারতবর্ষ)',
    },
    attributePage: {
        title: 'বৈশিষ্ট্য পরিবর্তন',
        viewChanges: 'পরিবর্তনগুলি দেখুন',
        dateTime: 'তারিখ',
        notificationType: 'নোটিফিকেশনের ধরন',
        notificationValue: 'নোটিফিকেশনের মান',
        oldValue: 'পুরানো মান',
        newValue: 'নতুন মান',
        accept: 'স্বীকার করুন',
        reject: 'প্রত্যাখ্যান করুন',
    },
    Home: 'হোম',
    load: 'প্রাথমিক ডেটা লোড হচ্ছে…',
    Requested: "অনুরোধ করা হয়েছে",
    Viewed: "দেখা হয়েছে",
    Executing: "কার্যকর করা হচ্ছে",
    Completed: "সম্পূর্ণ হয়েছে",
    Expired: "মেয়াদ শেষ হয়েছে",
    Cancelled: "বাতিল করা হয়েছে",
    Error: "ত্রুটি",
    Rejected: "প্রত্যাখ্যান করা হয়েছে",
    error: 'কিছু সমস্যা হয়েছে; পরে আবার চেষ্টা করুন।',
    displayname: 'ডিসপ্লে নাম',
    givenname: 'নাম',
    surname: 'পদবী',
    email: 'ইমেল',
    mail: 'ইমেল',
    name: 'নাম',
    firstname: 'নাম',
    lastname: 'পদবী',
    footer_copyright: 'সর্বস্বত্ব সংরক্ষিত।'
  };
  
  export default bnIN;
  